var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-wrap",class:{ active: _vm.switchActive },on:{"click":_vm.handleSwitch}},[_c('div',{staticClass:"switch-node"})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }